import {
  getErpTranslationNamespace,
  type GetErpTranslationNamespaceProps,
} from "src/system/getErpTranslationNamespace.ts";

export type UseErpTranslationNamespaceProps = GetErpTranslationNamespaceProps;

export const useErpTranslationNamespace = (
  props: UseErpTranslationNamespaceProps,
) => {
  return getErpTranslationNamespace(props);
};
